import { SalesChannelName } from 'core/ids';

import GeneralBasketServiceInterface from './general-basket-service-interface';

import * as ŃsfOffer from 'view/view/shared/offer/offer';

import GeneralSalesObjectInterface from 'service/general-sales-object/general-sales-object-interface';

import DeviceOffer from 'view/view/shared/offer/device-offer';
import SimOnlyOffer from 'view/view/shared/offer/sim-only-offer';

/**
 * @module SalesFlow/shopbackend
 */

export default class GeneralBasketServiceInterfaceBNT extends GeneralBasketServiceInterface {

    constructor (salesChannel: SalesChannelName, forApp: boolean, forAppConnection: boolean) {

        super (salesChannel, forApp, forAppConnection);

    }

    /**
     * Main offer is the NSF View Offer Type (SimOnlyOffer, DeviceOffer, HardwareOnlyOffer) that
     * includes every information we need. Red+ Items, Accessory Items, optional services ....
     * @param mainOffer
     * @param salesChannel
     * @param generalSalesObjectInterface
     */
    public executeOffer (mainOffer: ŃsfOffer.default, salesChannel: SalesChannelName, generalSalesObjectInterface: GeneralSalesObjectInterface): JQueryPromise<any> {

        this.init();

        this._salesChannel = salesChannel;
        this._generalSalesObjectInterface = generalSalesObjectInterface;

        // Offer Data in NSF Style
        this._NSF_Data.mainOffer = mainOffer;

        if (( mainOffer instanceof DeviceOffer || mainOffer instanceof SimOnlyOffer ) && 0 < mainOffer.redPlusOffers.length) {
            this._NSF_Data.redPlusOffer = mainOffer.redPlusOffers;
        }

        if (mainOffer instanceof DeviceOffer && 0 < mainOffer.accessories.length) {
            this._NSF_Data.accessoryOffer = mainOffer.accessories;
        }

        // First step: empty Basket
        this.clear();

        // generates Baskert Object out of NSF Offer (Including Red+)
        this.generateMainOfferFromNSFData();

        // Add Main Offer to Basket
        if ( mainOffer.isHardwareOnly() ) {
            this._basketFactory.putHardwareOnlyOfferIntoBasket(
                this._GSO_Data.mainOffer
            );
        } else {
            this._basketFactory.putNewContractOfferIntoBasket(
                this._GSO_Data.mainOffer,
                this._GSO_Data.redPlusOffer
            );
        }

        // Add Accessory Offer(s) to Basket
        this.generateAccessorysOfferFromNSFData();
        for (let i = 0; i < this._GSO_Data.accessoryOffer.length; i++) {
            this._basketFactory.putHardwareOnlyOfferIntoBasket(
                this._GSO_Data.accessoryOffer[i]
            );
        }

        return this.sendBasketToShopBackend();

    }

}
